import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "integrations" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "head" }
const _hoisted_4 = { class: "logo-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "controls" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Toggle = _resolveComponent("Toggle")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Button = _resolveComponent("Button")
  const _component_Segment = _resolveComponent("Segment")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createBlock(_component_SettingsFrame, {
    title: "Integrations and connected apps",
    description: "Supercharge your workflow and connect your top sources"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($options.loading)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" Loading"),
                _createElementVNode("br", null, null, -1 /* HOISTED */),
                _createTextVNode(" Please wait... ")
              ])),
              _: 1 /* STABLE */
            }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.integrations, (item) => {
              return (_openBlock(), _createBlock(_component_Segment, {
                key: item.name,
                raised: "",
                class: "integration-item",
                disabled: item.disabled,
                red: item.store.enabled && !item.store.connected
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("img", {
                          src: item.logo,
                          alt: "logo"
                        }, null, 8 /* PROPS */, _hoisted_5)
                      ]),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1 /* TEXT */),
                      _createVNode(_component_Toggle, {
                        modelValue: item.store.enabled,
                        "onUpdate:modelValue": $event => ((item.store.enabled) = $event),
                        class: "toggle",
                        onChange: (model) => $options.handleToggleChange(model, item.type, item)
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.description), 1 /* TEXT */)
                  ]),
                  _createVNode(_component_Divider, {
                    m: "0",
                    h: "0.1rem"
                  }),
                  _createElementVNode("div", _hoisted_8, [
                    (item.store.connected)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          primary: "",
                          text: "",
                          small: "",
                          onClick: () => $options.onDisconnect(item.store.type)
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode(" Disconnect ")
                          ]))]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          primary: "",
                          small: "",
                          onClick: () => $options.onConnect(item.store.type)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.store.enabled ? 'Reconnect' : 'Connect'), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                  ])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "red"]))
            }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}